module.exports = __webpack_public_path__ + "a72011ccdc2bcd23ba440f104c416193.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/layer/loading-0.gif
// module id = 1045
// module chunks = 75